import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useToast } from '../../hooks/use-toast';

interface LogoutButtonProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export default function LogoutButton({
  children = 'Logout',
  className,
  style,
}: LogoutButtonProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { logout } = useAuth();
  const { toast } = useToast();

  const handleLogout = async () => {
    setIsLoading(true);

    try {
      await logout();
      toast({
        title: 'Logged out successfully',
        description: 'See you next time!',
      });
    } catch (error) {
      toast({
        title: 'Logout failed',
        description:
          error instanceof Error ? error.message : 'An error occurred',
        variant: 'destructive',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleLogout}
      disabled={isLoading}
      className={className}
      style={style}
    >
      {isLoading ? 'Logging out...' : children}
    </button>
  );
}
